<template>
  <div class="main-content-container full-bg">
    <div class="top-content-container ml-3">
      <b-row>
        <b-col md="6">
          <b-breadcrumb class="position-relative" style="right: 1rem">
            <b-breadcrumb-item>
              <span
                @click="navigateToCustomers"
                class="text-uppercase font-family-medium"
              >
                Customers
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              <span class="text-uppercase font-family-medium">{{
                userName
              }}</span>
            </b-breadcrumb-item>
          </b-breadcrumb>
        </b-col>
        <b-row
          class="
            user-info-right
            flex-row
            d-flex
            justify-content-end
            position-absolute
            mt-3
          "
          align-v="center"
        >
          <b-col
            v-if="!isLoadingAvatar"
            class="w-100 flex-row d-flex flex-wrap align-items-center"
          >
            <b-avatar v-if="avatar" :src="avatar" size="8rem"></b-avatar>
            <b-avatar
              v-else
              :text="avatarName"
              size="8rem"
              class="bg--primary"
            ></b-avatar>
            <div
              class="
                user-info-content
                d-flex
                flex-column
                justify-content-center
                position-relative
                mt-3
              "
            >
              <p class="font-family-medium primary--text text-capitalize">
                {{ userName }}
              </p>
              <!-- <p class="secondary--text reduce-whitespace">
                {{ emailPrimary }}
              </p> -->
            </div>
          </b-col>
          <b-col
            v-else
            class="w-100 flex-row d-flex flex-wrap align-items-center"
          >
            <b-skeleton type="avatar" size="8rem"></b-skeleton>
            <div
              class="
                user-info-content
                d-flex
                flex-column
                justify-content-center
                position-relative
              "
            >
              <b-skeleton width="14rem"></b-skeleton>
              <b-skeleton width="14rem" class="mt-3"></b-skeleton>
            </div>
          </b-col>
        </b-row>
      </b-row>
    </div>

    <b-row class="general-info-form-group" style="margin-top: 1.9rem">
      <b-col md="12" class="">
        <ValidationObserver ref="observer">
          <b-form class="mt-5">
            <b-form-group class="d-flex font-family-regular primary-dark">
              <b-card class="d-flex flex-column general-info-card">
                <div class="d-flex flex-wrap">
                  <b-row class="w-100 my-0 mx-auto">
                    <b-col class="mb-4">
                      <ValidationProvider
                        name="Name field"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Name *">
                          <b-form-input
                            autocomplete="off"
                            size="lg"
                            type="text"
                            placeholder
                            v-model="userName"
                            disabled
                          ></b-form-input>
                          <h6
                            class="
                              font-sm
                              mb-3
                              font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            {{ errors && errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                    <!-- <b-col class="mb-4">
                      <ValidationProvider
                        name="Email field"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Email *">
                          <b-form-input
                            autocomplete="off"
                            size="lg"
                            type="text"
                            v-model="emailPrimary"
                            placeholder
                            disabled
                          ></b-form-input>
                          <h6
                            class="font-sm mb-3 font-family-regular position-absolute danger"
                          >
                            {{ errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col> -->
                    <b-col class="mb-4">
                      <ValidationProvider
                        name="Phone Number field"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Mobile phone number *">
                          <b-form-input
                            autocomplete="off"
                            class="cy-new-intake-ph"
                            size="lg"
                            v-model="phone"
                            type="number"
                            placeholder="Enter phone number"
                          ></b-form-input>
                          <h6
                            class="
                              font-sm
                              cy-new-intake-ph-err
                              mb-3
                              font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            {{ errors && errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row class="w-100 my-0 mx-auto"></b-row>
                  <b-row class="w-100 my-0 mx-auto">
                    <b-col class="mb-4">
                      <ValidationProvider
                        name="Time zone field"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Timezone *">
                          <b-form-select
                            :options="timeZone"
                            v-model="selectedTimeZone"
                            class="cy-new-intake-timezone"
                          ></b-form-select>
                          <h6
                            class="
                              font-sm
                              cy-new-intake-timezone-err
                              mb-3
                              font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            {{ errors && errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>

                    <b-col class="mb-4" md="12" v-if="company">
                      <b-form-group label="Company *">
                        <b-form-input
                          v-model="company.name"
                          type="text"
                          size="lg"
                          disabled
                        />
                      </b-form-group>
                    </b-col>

                    <b-col class="mb-4" md="12" v-if="billingEntity">
                      <b-form-group label="Public Support Billing Entity *">
                        <b-form-input
                          v-model="billingEntityLabel"
                          type="text"
                          size="lg"
                          disabled
                        />
                      </b-form-group>
                    </b-col>
                    <b-col class="mb-4">
                      <ValidationProvider
                        name="Language field"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Language *">
                          <b-form-select
                            :options="language"
                            v-model="selectedLanguage"
                            class="cy-new-intake-lang"
                          ></b-form-select>
                          <h6
                            class="
                              font-sm
                              cy-new-intake-lang-err
                              mb-3
                              font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            {{ errors && errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row class="w-100 mx-auto mt-4">
                    <b-col class="mb-4">
                      <ValidationProvider
                        name="Linkedin field"
                        rules="linkedinRegex"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Linkedin">
                          <b-form-input
                            autocomplete="off"
                            size="lg"
                            class="cy-new-intake-linkedin"
                            type="text"
                            placeholder="Enter Linkedin URL"
                            v-model="linkedin"
                          ></b-form-input>
                          <h6
                            class="
                              font-sm
                              cy-new-intake-linkedin-err
                              mb-3
                              font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            {{ errors && errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                    <b-col class="mb-4">
                      <ValidationProvider
                        name="Infrastructure field"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Infrastructure *">
                          <multiselect
                            data="cy-new-intake-infra"
                            placeholder="Select Infrastructure"
                            v-model="infrastructure"
                            label="text"
                            track-by="id"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            class="
                              custom-multiselect
                              cy-new-intake-infra
                              categories-multiselect
                            "
                            :options="infraOptions"
                            :multiple="true"
                          >
                            <template slot="singleLabel" slot-scope="props">
                              <span class="option__desc">
                                <span class="option__title">
                                  {{ props.option.title }}
                                </span>
                              </span>
                            </template>
                          </multiselect>
                          <h6
                            class="
                              font-sm
                              cy-new-intake-infra-err
                              mb-3
                              font-family-regular
                              position-absolute
                              danger
                            "
                            data-cy="customer-infra-required-error"
                          >
                            {{ errors && errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row class="w-100 my-0 mx-auto mt-4">
                    <b-col class="mb-4">
                      <b-form-group label="Subscription plan *">
                        <b-form-input
                          v-model="membershipTitle"
                          disabled
                          class="cy-new-intake-subs"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col class="mb-4">
                      <b-form-group label="Subscription hours per month *">
                        <b-form-input
                          v-model="membershipHours"
                          disabled
                          class="cy-new-intake-subs-hrs"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row class="w-100 mx-auto mt-4">
                    <b-col class="mb-4">
                      <ValidationProvider
                        name="Profile type field"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Profile type *">
                          <multiselect
                            placeholder="Select Profile Type"
                            v-model="selectedProfileType"
                            label="text"
                            class="
                              custom-multiselect
                              cy-new-intake-infra
                              categories-multiselect
                            "
                            track-by="id"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            data="cy-new-intake-profile-type"
                            :options="profileType"
                            :multiple="true"
                          >
                            <template slot="noResult"
                              >No profile found</template
                            ></multiselect
                          >
                          <h6
                            class="
                              font-sm
                              mb-3
                              font-family-regular
                              position-absolute
                              danger
                            "
                            data-cy="customer-ptype-required-error"
                          >
                            {{ errors && errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                    <b-col class="mb-4">
                      <ValidationProvider
                        name="Deepdive date field"
                        rules="required|date"
                        v-slot="{ errors }"
                      >
                        <b-form-group label="Deepdive date *">
                          <b-input-group>
                            <b-form-input
                              style="background: #fff"
                              v-model="startDate"
                              type="text"
                              class="cy-new-intake-date"
                              placeholder="YYYY-MM-DD"
                              autocomplete="off"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-form-datepicker
                                v-model="startDate"
                                button-only
                                :show-decade-nav="true"
                                right
                                class="datepicker"
                                locale="en-US"
                                aria-controls="example-input"
                                @context="onContext"
                              >
                                <template #button-content="">
                                  <img
                                    src="@/assets/icons/date-picker.svg"
                                    alt=""
                                  />
                                </template>
                              </b-form-datepicker>
                            </b-input-group-append>
                          </b-input-group>
                          <h6
                            class="
                              font-sm
                              cy-new-intake-date-err
                              mb-3
                              font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            {{ errors && errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row class="w-100 my-0 mx-auto mt-4">
                    <b-col class="mb-4">
                      <ValidationProvider v-slot="{ errors }">
                        <b-form-group
                          :label="question.question.title"
                          v-for="question in questions"
                          :key="question.id"
                          class="questions-list"
                        >
                          <multiselect
                            v-if="
                              question.question.questionType ===
                              'MULTIPLE_CHOICE'
                            "
                            placeholder="Select Tasks"
                            v-model="question.answer"
                            label="text"
                            track-by="id"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            class="
                              custom-multiselect
                              cy-new-intake-tasks
                              mb-3
                              categories-multiselect
                              tasks-categories
                            "
                            :options="question.question.options"
                            :multiple="true"
                          >
                            <template slot="singleLabel" slot-scope="props">
                              <span class="option__desc">
                                <span class="option__title">
                                  {{ props.option.title }}
                                </span>
                              </span>
                            </template>
                          </multiselect>
                          <b-form-textarea
                            v-else
                            autocomplete="off"
                            rows="3"
                            no-resize
                            class="cy-new-intake-ans"
                            v-model="question.answer"
                          ></b-form-textarea>
                          <h6
                            class="
                              font-sm
                              mb-3
                              font-family-regular
                              position-absolute
                              danger
                            "
                          >
                            {{ errors && errors[0] }}
                          </h6>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                </div>
              </b-card>
            </b-form-group>
          </b-form>
        </ValidationObserver>
      </b-col>
    </b-row>

    <b-row align-v="center" class="mt-4 mx-0">
      <b-alert
        v-if="showValidity"
        :show="showValidity"
        class="cy-new-intake-alert alert-btn-top custom-alert ml-2"
      >
        <p>There are invalid form fields</p>
      </b-alert>
    </b-row>
    <b-row align-v="center" class="mx-0">
      <!-- <b-alert
        :show="totalApiCalls.length === passedApiCalls.length"
        class="alert-btn-top custom-alert"
        v-if="totalApiCalls.length === passedApiCalls.length"
      >
        <p>Customer created</p>
      </b-alert> -->
      <b-alert
        :show="totalApiCalls.length !== passedApiCalls.length"
        v-if="totalApiCalls.length !== passedApiCalls.length"
        class="alert-btn-top ml-3 custom-alert"
      >
        <p v-if="tokenError">
          User token expired. Please logout and login again.
        </p>
        <p v-else>Some error occured</p>
      </b-alert>
    </b-row>
    <b-row>
      <b-button
        class="cy-new-intake-save btn-pill px-5 py-3 mt-2"
        @click.prevent="saveCustomer"
        style="margin-left: 2rem; margin-bottom: 5rem"
      >
        <b-spinner
          v-if="pageLoading"
          style="width: 14px; height: 14px"
          variant="light"
          label="Spinning"
        ></b-spinner>
        {{ `${!pageLoading ? "Save" : ""}` }}
      </b-button>
    </b-row>
  </div>
</template>

<script>
import {
  infraOptions,
  languages,
  linkedinRegex,
  profileTypes,
  subscriptionTypes,
  timeZones
} from "@/utils/constants/index";
import {
  ValidationProvider,
  ValidationObserver,
  extend
} from "vee-validate/dist/vee-validate.full";
import moment from "moment";
import { email, required } from "vee-validate/dist/rules";
import { getCommunicationIDs } from "@/apis/auth/index";
import { getFormDetails, postCommunications } from "@/apis/customers/index";
import Multiselect from "vue-multiselect";
import {
  getCustomer,
  patchCustomerOtherDetails,
  formSubmission,
  getForm
} from "@/apis/customers";
import { mapState } from "vuex";
extend("email", {
  ...email,
  message: "Email is not valid"
});

let linkedinErrorMessage =
  "Linkedin URL should be in this format: https://www.linkedin.com/in/dave";
extend("linkedinRegex", {
  message: () => `${linkedinErrorMessage}`,
  validate: value => {
    let mustContainTheseChars = linkedinRegex;
    let containsRequiredChars = mustContainTheseChars.test(value);
    if (containsRequiredChars) {
      return true;
    } else {
      linkedinErrorMessage =
        "Linkedin URL should be in this format: https://www.linkedin.com/in/dave";
      return false;
    }
  }
});
let dateMessage = "YYYY-MM-DD format required";
extend("date", {
  message: () => dateMessage,
  validate: value => {
    let mustContainTheseChars = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
    let containsRequiredChars = mustContainTheseChars.test(value);
    if (containsRequiredChars) {
      return true;
    } else {
      return false;
    }
  }
});

extend("required", {
  ...required,
  message: () => "This is a required field"
});

export default {
  name: "NewCustomerIntake",

  components: {
    ValidationObserver,
    ValidationProvider,
    Multiselect
  },

  data() {
    return {
      formID: "",
      tokenError: false,
      company: null,
      membershipHours: null,
      linkedinURL: false,
      firstName: "",
      lastName: "",
      showValidity: false,
      userName: "",
      totalApiCalls: [],
      passedApiCalls: [],
      successModal: false,
      success: false,
      max: 10,
      value: 5,
      showListView: false,
      initials: [],
      pageLoading: false,
      assistantsList: [],
      paLoading: false,
      password: "",
      value2: "",
      phone: "",
      avatar: "",
      avatarName: "",
      emailPrimary: "",
      formatted: "",
      customerRole: "",
      phoneID: "",
      min: moment().format("YYYY-MM-DD"),
      selected: "",
      startDate: "",
      emailSecondary: "",
      workHours: "",
      selectedPA: {},
      customerID: "",
      infrastructure: [],
      infraOptions: infraOptions,
      linkedin: "",
      membershipTitle: null,
      formErrors: false,
      showSelectionModal: false,
      profileID: "",
      questions: [],
      answers: [],
      subscriptionPlan: subscriptionTypes,
      selectedProfileType: [],
      profileType: profileTypes,
      selectedTimeZone: null,
      timeZone: timeZones,
      selectedLanguage: null,
      language: languages,
      dateOfJoining: "",
      communicationsList: [],
      isLoadingAvatar: true,
      billingEntityOptions: [
        { value: null, text: "Please select a Billing Entity" },
        { value: "EU", text: "Public Support Assistance BV (EU)" },
        { value: "US", text: "Public Support Assistance Services LLC (US)" }
      ],
      billingEntity: null,
      billingEntityLabel: null
    };
  },

  created() {
    this.customerID = this.$route.params.pid;
    this.getCustomerInfo();
    this.getIntakeInfo();
  },

  computed: {
    ...mapState("authModule", ["role"])
  },

  methods: {
    getCustomerInfo() {
      getCustomer(this.customerID)
        .then(res => {
          this.customerRole = res.data.role.name;

          const { firstName, lastName, email, avatarThumbnail } = res.data.user;
          this.firstName = firstName;
          this.lastName = lastName;
          this.userName = `${this.firstName} ${this.lastName}`;
          this.avatar = avatarThumbnail;
          this.avatarName =
            this.firstName.charAt(0).toUpperCase() +
            this.lastName.charAt(0).toUpperCase();

          const {
            id,
            billingEntity,
            membership,
            membershipHours,
            company
          } = res.data.profile;
          this.profileID = id;
          this.emailPrimary = email;
          this.company = company;
          this.billingEntity = billingEntity;
          this.billingEntityLabel = this.getTextFromValue(
            this.billingEntityOptions,
            billingEntity
          );
          this.membershipTitle = membership.title;
          this.membershipHours = membershipHours;
        })
        .catch(err => {
          console.error(err);
          this.isLoadingAvatar = false;
        })
        .finally(() => {
          this.isLoadingAvatar = false;
        });
    },
    getIntakeInfo() {
      getForm()
        .then(res => {
          res.data.results.map(item => {
            let id = item.id;
            this.formID = id;
            getFormDetails(id)
              .then(res => {
                this.questions = res.data.formQuestions.sort(
                  (a, b) => a.order - b.order
                );
                this.questions.map(item => {
                  item.formID = id;
                  if (item.question.questionType === "MULTIPLE_CHOICE") {
                    item.answer = [];
                    item.question.options.map((op, index) => {
                      op.text = op.title;
                      op.id = index;
                      return op;
                    });
                  } else {
                    item.answer = "";
                  }
                });
              })
              .catch(err => console.error(err));
          });
        })
        .then(() => {
          getCommunicationIDs("customer")
            .then(res => {
              this.communicationsList = [...res.data.results];
            })
            .catch(err => console.error(err));
        })
        .catch(err => console.error(err));
    },

    navigateToCustomers() {
      if (this.role === "assistant") {
        this.$router.push({ name: "DedicatedCustomers" });
      } else if (this.role === "admin") {
        this.$router.push({
          name: "CustomersListAdmin",
          query: {
            tab: 0
          }
        });
      }
    },
    backToForm() {
      this.selectedPA = {};
      this.showSelectionModal = false;
    },
    assignPa() {
      this.$router.push({
        name: "AssignPAtoCustomer",
        params: {
          id: this.customerID
        }
      });
    },
    async saveCustomer() {
      this.showValidity = false;
      this.totalApiCalls.length = 0;
      this.passedApiCalls.length = 0;
      this.linkedinURL = "";

      const valid = await this.$refs.observer.validate();
      if (valid) {
        this.pageLoading = true;
        const data = {
          profile: this.customerID,
          membership: this.membershipTitle,
          membershipHours: this.membershipHours,
          profileType: { selectedProfileTypes: this.selectedProfileType },
          timezone: this.selectedTimeZone,
          language: this.selectedLanguage,
          linkedin: this.linkedin,
          communicationManager: {
            selectedMedium: this.infrastructure
          },
          startDate: this.startDate,
          billingCountry: this.billingEntity
        };

        patchCustomerOtherDetails(this.customerID, this.profileID, data)
          .then(() => {
            this.tokenError = false;
            this.passedApiCalls.push(true);
            const answerData = [];
            for (let i = 0; i < this.questions.length; i++) {
              if (
                this.questions[i].question.questionType === "MULTIPLE_CHOICE"
              ) {
                let arr = [];
                this.questions[i].answer.map(item => {
                  arr.push({
                    title: item.title
                  });
                });
                this.questions[i].answer = arr;
              }
            }
            for (let i = 0; i < this.questions.length; i++) {
              answerData.push({
                answer: {
                  answer: this.questions[i].answer
                },
                profile: this.customerID,
                form: this.questions[i].formID,
                question: this.questions[i].id
              });
            }
            formSubmission(this.formID, answerData)
              .then(() => {
                this.success = true;
                this.passedApiCalls.push(true);
              })
              .catch(err => {
                this.success = false;
                console.error(err.response.data);
                this.pageLoading = false;
              })
              .finally(() => {
                this.totalApiCalls.push(true);
              });
            let payload = [];
            for (let i = 0; i < this.communicationsList.length; i++) {
              let value = "";

              if (this.communicationsList[i].order === 2) {
                value = this.phone;
              } else if (this.communicationsList[i].order === 4) {
                value = "See 1PW";
              }
              payload.push({
                communication: this.communicationsList[i].id,
                value
              });
            }

            postCommunications(this.customerID, payload)
              .then(() => {
                this.passedApiCalls.push(true);
              })
              .catch(err => {
                console.error(err);
                this.pageLoading = false;
              })
              .finally(() => {
                this.totalApiCalls.push(true);
              });
          })
          .catch(err => {
            this.success = false;
            console.error(err.response.data);

            if (err.response.status === 401) {
              this.tokenError = true;
            } else {
              this.linkedinURL = err.response.data.linkedin[0];
            }
          })
          .finally(() => {
            this.totalApiCalls.push(true);
            this.successModal = true;
            if (this.totalApiCalls.length === this.passedApiCalls.length) {
              this.pageLoading = false;
              this.assignPa();
            } else {
              this.pageLoading = false;
            }
          });
      } else {
        this.showValidity = true;
      }
    },
    onContext(ctx) {
      // The date formatted in the locale, or the `label-no-date-selected` string
      this.formatted = ctx.selectedFormatted;
      // The following will be an empty string until a valid date is entered
      this.selected = ctx.selectedYMD;
    },
    workHoursToInteger(work_hours) {
      return Number(work_hours);
    },

    getTextFromValue(options, targetValue) {
      return options.find(({ value }) => targetValue === value)?.text;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>;
<style scoped lang="scss">
.questions-list:last-child {
  margin-bottom: 0rem;
}
.questions-list:not(:last-child) {
  margin-bottom: 3rem;
}
.full-bg {
  height: 100% !important;
}
.user-info-right {
  right: 5rem;
  top: 1rem;
}
.user-info-content {
  left: 2rem;
}
.general-info-form-group {
  flex: 0 0 50%;
}
.general-info-card {
  padding: 0.5rem;
}
.communication-icons {
  width: 40px;
  height: 40px;
}
.communication-icons img {
  object-fit: cover;
  width: inherit;
  position: relative;
  bottom: 0rem;
}
</style>
